import React, { useState, useEffect } from 'react'
import pathname from '../../constants/pathname'
import ProjectDataTable from '../dataTable/ProjectDataTable'
import { useHistory } from 'react-router-dom'
import { getWaitScreening } from '../../redux/actions/dashboard'
import DashboradToggle from './DashboradToggle'
import TableLoadingTemplate from '../loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'

export default function WaitScreening({ config, onSettingChange = () => {} }) {
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  let history = useHistory()

  // let id = location.search.substring(1)
  let id = sessionStorage.getItem('param')?.substring(1)

  useEffect(() => {
    if (config) {
      setSchema(settingSchema)
    } else {
      handelGetSchemaDashboard(5, 1)
    }
  }, [])

  const handelGetSchemaDashboard = async (
    pagesize,
    pagenumber,
    projectCodeSearch,
    projectNameSearch
  ) => {
    setIsLoading(true)
    // startLoading()
    try {
      const response = await getWaitScreening(
        pagesize,
        pagenumber,
        projectCodeSearch,
        projectNameSearch
      )
      // console.log('getWaitScreening => ', response)
      setSchema(response)
    } catch (e) {
      setError({})
    }
    // doneLoading()
    setIsLoading(false)
  }

  const onMultiSubmit = (selectList) => {
    console.log('WaitForScrutinize onSubmit', selectList)

    let idList = selectList.map((element) => {
      return element.id
    })

    sessionStorage.setItem('mutiReview', idList)
    sessionStorage.setItem('projectId', 'multi-reveiw')
    sessionStorage.setItem('param', '')

    return history.push({
      pathname: `${pathname.proposal.review.projectList}`,
      state: { selectId: idList },
    })
  }

  const onSingleSubmit = (obj) => {
    sessionStorage.setItem('projectId', obj.id)
    sessionStorage.setItem('param', '')
    // console.log('id', obj.ig)
    history.push(`${pathname.proposal.overview.overviewCoworker}`)
  }

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}
          <ProjectDataTable
            schema={schema}
            subName={{ enable: true }}
            multi={{ enable: false, buttonText: 'ไปยังการคัดกรอง' }}
            single={{
              enable: true,
              buttonText: schema?.buttonText,
              icon: schema?.singleIcon,
            }}
            onSingleSubmit={onSingleSubmit}
            onMultiSubmit={onMultiSubmit}
            pagination={true}
            onReload={handelGetSchemaDashboard}
            loading={isLoading}
            searchEnable={true}
            setting={config && true}
            // config={config}
            // onSettingChange={onSettingChange}
          />
        </>
      )}
    </>
  )
}

const settingSchema = {
  header: 'โครงการที่รอคัดกรอง',
  projectCodeText: 'รหัสโครงการ',
  projectNameText: 'ชื่อโครงการ',
  projectTypeText: 'ประเภทโครงการ',
  projectBudgetText: 'งบประมาณรวม',
  buttonText: 'คัดกรอง',
  totalSize: 1,
  values: [
    {
      id: 'XXX',
      projectCode: 'XX-XXXXX',
      projectName: {
        name: 'โครงการ XXX',
        statusName: 'XXX',
      },
      projectBudget: '0.00',
      projectType: {
        value: 'โครงการ',
        label: '1',
      },
    },
  ],
}
